// extracted by mini-css-extract-plugin
export default {"wrapper":"PasswordInput_wrapper__fqkNi","icon":"PasswordInput_icon__K+ZZ+"};